import { render, staticRenderFns } from "./Protocol.vue?vue&type=template&id=b14bf128&scoped=true"
import script from "./Protocol.vue?vue&type=script&lang=js"
export * from "./Protocol.vue?vue&type=script&lang=js"
import style0 from "./Protocol.vue?vue&type=style&index=0&id=b14bf128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_bc0963b6aefcdd755d0d0b687a7bc856/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14bf128",
  null
  
)

export default component.exports